export default function MiniMovers() {
	return (
		<div className="px-6 sm:px-8">
			<div className="mx-auto max-w-2xl pt-4 text-center">
				<h2 className="text-2xl font-bold tracking-tight text-white sm:text-4xl">
					Mini Movers
				</h2>
				<p className="text-[#f9c04d]">(Ages 5-7)</p>
				<p className="mt-6 text-sm font-bold text-stone-300 sm:text-base">
					With five styles of dance offered, Ballet, Tap, Jazz, Musical Theatre
					& Hip Hop, your young dancer will discover what they love most! Our
					summer Mini Mover classes include dancing, games, crafts and a show
					the last 10 minutes of each class!
				</p>
			</div>
			<div className="mt-8 border-t border-stone-600 font-bold">
				<dl className="divide-y divide-stone-600">
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Rhythm Makers (Tap)</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 8</div>
								<div className="grid justify-end">10:00-11:45am</div>
							</div>
						</dd>
					</div>
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Rhythm Makers (Tap)</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 8</div>
								<div className="grid justify-end">4:30-6:15pm</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Petite Pop Stars (Jazz)</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 15</div>
								<div className="grid justify-end">10:00-11:45am</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Petite Pop Stars (Jazz)</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 15</div>
								<div className="grid justify-end">4:30-6:15pm</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">
							Magical Movers (Lyrical & Ballet)
						</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 22</div>
								<div className="grid justify-end">10:00-11:45am</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">
							Magical Movers (Lyrical & Ballet)
						</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 22</div>
								<div className="grid justify-end">4:30-6:15pm</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">
							Broadway Bound (Musical Theatre)
						</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 29</div>
								<div className="grid justify-end">10:00-11:45am</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">
							Broadway Bound (Musical Theatre)
						</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 29</div>
								<div className="grid justify-end">4:30-6:15pm</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Glow Party (Hip Hop)</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">August 5</div>
								<div className="grid justify-end">10:00-11:45am</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Glow Party (Hip Hop)</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">August 5</div>
								<div className="grid justify-end">4:30-6:15pm</div>
							</div>
						</dd>
					</div>
				</dl>
				<div className="mx-auto mt-12 max-w-xl space-y-4 border-t border-stone-600 text-center">
					<div className="space-y-2 rounded-lg border border-[#f9c04d] p-4 text-xs text-stone-100 sm:text-sm">
						<div>Drop in fee: $30</div>
						<div>Five week session: $140</div>
					</div>
				</div>
			</div>
		</div>
	)
}
